/**
 * Page-aware quick prompts surfaced at the top of the Suggestions view.
 * Keyed by the BP sub-route slug returned from useGuruContext.subSurface.
 *
 * Each list is what a user is most likely to want help with while sitting on
 * that page. Keep prompts short, action-oriented, and in British English.
 */

const BP_SUB_SURFACE_PROMPTS = {
  wiki: [
    'What changed in the wiki since the last regeneration?',
    'Show me the wiki regeneration history',
    'Which wiki sections look weakest or have the fewest sources?',
    'Summarise this Building Passport in one paragraph',
  ],
  other: [
    'Which documents are missing expiry dates?',
    'List unclassified files I should review',
    'Find documents related to fire safety',
    'Which categories are missing required documents?',
  ],
  compliance: [
    'What compliance gaps need attention?',
    'Which certificates expire in the next 90 days?',
    'Which HRB requirements are unmet?',
    'Suggest evidence for missing checklist items',
  ],
  units: [
    'Compare unit occupancy and roles',
    'Which units have no occupants?',
    'Summarise recent unit changes',
  ],
  notes: [
    'Summarise the most recent notes',
    'Find notes about ongoing works',
    'Are there any unresolved questions in notes?',
  ],
  inbox: [
    'Summarise the most recent emails',
    'Pull action items from the inbox',
    'Which emails mention safety or compliance?',
  ],
  emails: [
    'Summarise the most recent emails',
    'Pull action items from the inbox',
  ],
  accessControl: [
    'List every Building Passport user with their role',
    'Who is the principal accountable person?',
    'Which roles need review?',
  ],
  reporting: [
    'Open the latest audit report',
    'Compare current compliance to last quarter',
  ],
  guru: [],
  tasks: [
    'Which tasks are overdue?',
    'What is pending approval right now?',
    'Summarise tasks by assignee',
    'Show tasks due this week',
  ],
  actions: [
    'List open critical actions',
    'Which actions are overdue?',
    'Group similar actions to convert in bulk',
    'Suggest who to assign open actions to',
  ],
  incidents: [
    'List unresolved incidents',
    'Summarise incidents this quarter',
    'Suggest follow-up remedials for the most recent incident',
  ],
  calendar: [
    'What is due this week?',
    'Show recurring tasks for the next 30 days',
    'Spot scheduling conflicts',
  ],
}

const PORTFOLIO_PROMPTS = [
  'Which Building Passports have overdue documents?',
  'Compare compliance across all Building Passports',
  'Show me critical open actions across the portfolio',
]

const BP_DEFAULT_PROMPTS = [
  'Give me an overview of this Building Passport',
  'What needs my attention here?',
  'Which certificates expire soon?',
]

export function quickPromptsFor({ contextType, subSurface }) {
  if (contextType === 'portfolio') return PORTFOLIO_PROMPTS
  if (contextType !== 'bp') return []
  if (subSurface && BP_SUB_SURFACE_PROMPTS[subSurface]) {
    return BP_SUB_SURFACE_PROMPTS[subSurface]
  }
  return BP_DEFAULT_PROMPTS
}

export function subSurfaceLabel(subSurface) {
  return {
    wiki: 'Wiki',
    other: 'Documents',
    compliance: 'Compliance',
    units: 'Units',
    notes: 'Notes',
    inbox: 'Inbox',
    emails: 'Inbox',
    accessControl: 'Access',
    reporting: 'Reports',
    guru: 'Guru',
    tasks: 'Tasks',
    actions: 'Actions',
    incidents: 'Incidents',
    calendar: 'Calendar',
  }[subSurface] || null
}
